import React, { useEffect, useState } from 'react';
import { Form, InputGroup, Table, Button } from 'react-bootstrap';
import { IoMdAdd, IoMdSync } from 'react-icons/io';
import { IoCreateOutline, IoTrashOutline } from 'react-icons/io5';
import { format } from 'date-fns';

function BasicPrices({ unitMeasure, basicPrice, setBasicPrice }) {

  const [data, setData] = useState({
    addedOn: '',
    index: null,
    date: '',
    price: '',
    updatedOn: '',
  });
  const [inputError, setInputError] = useState(null);

  function handleChange(e) {
    const { id, value } = e.target;
    setInputError({ ...inputError, [id]: '' });
    setData((prevData) => {
      return { ...prevData, [id]: value };
    });
  }

  useEffect(() => {
    setData({ ...data, date: new Date() });
  }, []);

  function handleData() {
    if (data && data.date && data.price) {
      if (data && data.index === null) {
        let tempData = [...basicPrice];
        tempData.push({ price: data.price, date: data.date, addedOn: new Date(), updatedOn: new Date() });
        setBasicPrice(tempData);
      } else {
        let tempData = [...basicPrice];
        tempData[data.index].date = data.date;
        tempData[data.index].price = data.price;
        setBasicPrice(tempData);
      }
    } else {
      if (data && !data.date) {
        setInputError({ ...inputError, date: 'This field is required.' });
      } else if (data && !data.price) {
        setInputError({ ...inputError, price: 'This field is required.' });
      }
    }

    setData({ index: null, date: new Date(), price: '', addedOn: null, updatedOn: null });
  }

  function handleDeleteData(index) {
    let tempData = basicPrice;
    tempData.splice(index, 1);
    setBasicPrice(tempData);
    setData({ index: null, date: new Date(), price: '', addedOn: null, updatedOn: null });
  }

  return (
    <>
      <div className='p-3'>
        <h6>Basic Price List *</h6>
        <Table bordered>
          <thead>
            <tr className='bg-light'>
              <th className='ps-3'><small>Date</small></th>
              <th className='text-center'><small>Price</small></th>
              <th className='w-180px'></th>
            </tr>
          </thead>
          {
            basicPrice && basicPrice.length > 0 ?
              <tbody>
                {
                  basicPrice && basicPrice.length > 0 && basicPrice.map((item, index) => {
                    let priceDate = null;
                    if (item.date && item.date.seconds) {
                      priceDate = item.date.seconds * 1000;
                      item.date = new Date(priceDate);
                    }

                    return (
                      <tr key={index}>
                        <td className='ps-3'>{format(item && item.date, "dd-MM-yyyy")}</td>
                        <td className='text-center'>₹{item.price}/{unitMeasure}</td>
                        <td className='w-180px d-flex align-items-center justify-content-center'>
                          <Button
                            variant='none'
                            size='sm'
                            className='p-1 text-primary border-0 rounded px-2'
                            onClick={() => setData({ addedOn: item.addedOn, index: index, date: item.date, price: item.price, updatedOn: item.updatedOn })}
                          >
                            <IoCreateOutline size={18} />
                          </Button>
                          <Button
                            variant='none'
                            size='sm'
                            className='p-1 text-danger border-0 rounded px-2'
                            onClick={() => handleDeleteData(index)}
                          >
                            <IoTrashOutline size={18} />
                          </Button>
                        </td>
                      </tr>
                    )
                  })
                }
              </tbody>
              :
              null
          }
        </Table>
      </div>
      <div className='row p-3'>
        <div className='col-md-5 col-12'>
          <Form.Group className="mb-3" controlId="date">
            <Form.Label>Date of Price *</Form.Label>
            <Form.Control
              type="date"
              value={data && data.date ? format(data.date, "yyyy-MM-dd") : ''}
              onChange={(event) => setData({ ...data, date: new Date(event.target.value) })}
              className={inputError && inputError.date ? 'border-left-0 border-right-0 border-danger' : 'border-left-0 border-right-0'}
            />
            <Form.Control.Feedback type="invalid">{inputError && inputError.date}</Form.Control.Feedback>
          </Form.Group>
        </div>
        <div className='col-md-5 col-12'>
          <Form.Group className="mb-3 w-100 me-4" controlId="price">
            <Form.Label>Basic Price *</Form.Label>
            <InputGroup>
              <InputGroup.Text>₹</InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Enter basic price"
                className={inputError && inputError.price ? 'border-left-0 border-right-0 border-danger' : 'border-left-0 border-right-0'}
                onChange={handleChange}
                value={data && data.price}
                isInvalid={inputError && inputError.price}
              />
              <InputGroup.Text>per {unitMeasure}</InputGroup.Text>
              <Form.Control.Feedback type="invalid">{inputError && inputError.price}</Form.Control.Feedback>
            </InputGroup>
          </Form.Group>
        </div>
        <div className='col-md-2 col-12'>
          <Form.Label></Form.Label>
          {
            data && data.index !== null ?
              <Button
                variant='warning'
                onClick={handleData}
                className='py-2 px-0 mt-2 w-100'
                size='sm'
              >
                <IoMdSync size={18} />
                <div className='ms-1'>Update</div>
              </Button>
              :
              <Button
                variant='success'
                onClick={handleData}
                className='py-2 px-0 mt-2 w-100'
                size='sm'
              >
                <IoMdAdd size={18} />
                <div className='ms-1'>Add</div>
              </Button>
          }
        </div>
      </div>
    </>
  );
}

export default BasicPrices;
